<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Supply_Warehouse_Title' | translateWF: 'Supply Warehouse' }}</h1>
        <div class="page__title_buttons">
          <p-speeddial [model]="documentItems" direction="left" [transitionDelay]="80">
            <ng-template #button let-toggleCallback="toggleCallback">
              @if (canCreate()) {
                <p-button (click)="toggleCallback($event)" label="Inbound/Outbound" icon="pi pi-plus" iconPos="left"></p-button>
              }
              <p-button [outlined]="true" severity="secondary" (click)="onLocationToggle()" pTooltip="Click to switch warehouse" tooltipPosition="bottom">
                <i class="pi pi-box mr-2"></i>
                <span>{{ selectedLocationLabel() }}</span>
              </p-button>
            </ng-template>
            <span class="separator"></span>
            <ng-template #item let-item let-toggleCallback="toggleCallback">
              <p-button variant="outlined" severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label"></p-button>
            </ng-template>
          </p-speeddial>
        </div>
      </div>
    </div>

    <p-selectbutton [formControl]="selectedSection" [options]="section" optionLabel="label" optionValue="value" unselectable="true" />

    <section>
      <div class="grid-1 gap-[2rem]">
        @switch (selectedSection.value) {
          @case (1) {
            <div class="cs-page-list-grid">
              <!-- Filters Panel -->
              @if (purchaseOrderFilterConfig() && showFilters()) {
                <csl-dynamic-filters [filterConfig]="purchaseOrderFilterConfig()!" [state]="purchaseOrderFilterState" />
              }

              <!-- Data Table Panel -->
              <p-panel [header]="'Purchase_Orders' | translateWF: 'Purchase Orders'">
                <ng-template pTemplate="icons">
                  <p-button
                    [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                    [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                    (click)="showFilters.set(!showFilters())"
                    variant="outlined"
                    size="small"
                  />
                </ng-template>
                <p-card data-variant="compact">
                  <p-table [value]="purchaseOrderList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTablePurchaseOrderSort($event)">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
                        <th pSortableColumn="purchaseOrderNumber">
                          {{ 'Purchase_Order_PO_Number' | translateWF: 'PO Number' }}
                          <p-sortIcon field="purchaseOrderNumber"></p-sortIcon>
                        </th>
                        <th>{{ 'Purchase_Order_Date_Created' | translateWF: 'Date Created' }}</th>
                        <th>{{ 'Purchase_Order_Status' | translateWF: 'Status' }}</th>
                        <th>{{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}</th>
                        <th>{{ 'Purchase_Order_ShippingTo' | translateWF: 'Shipping To' }}</th>
                        <th>{{ 'Purchase_Order_BillingTo' | translateWF: 'Billing To' }}</th>
                        <th>{{ 'Purchase_Order_Goods_Receipt_Number' | translateWF: 'Goods Receipt Number' }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-po>
                      <tr class="cursor-pointer">
                        <td>
                          <p-button
                            icon="pi pi-eye"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            (click)="navigateToGRN(po.id)"
                            pTooltip="{{ 'Common_View_Details' | translateWF: 'View Details' }}"
                            tooltipPosition="top"
                          />
                        </td>
                        <td>
                          <div class="flex items-center gap-2">
                            <a class="whitespace-nowrap">{{ po.purchaseOrderNumber }}</a>
                            @if (isAdministrativePurchaseOrder(po)) {
                              <p-tag severity="warn" [value]="'Purchase_Order_Administrative' | translateWF: 'Administrative'" />
                            }
                          </div>
                        </td>
                        <td>{{ po.createdDate | date: 'dd/MM/yyyy' : 'UTC-6' }}</td>
                        <td>{{ statusesOrder()[po.status] }}</td>
                        <td>{{ getSpecificProvider(po.provider) }}</td>
                        <td>{{ getSpecificShippingTo(po.shipTo) }}</td>
                        <td>{{ getSpecificBillTo(po.billTo) }}</td>
                        <td>{{ (po.goodsReceiptNumbers ?? []).join(', ') || '-' }}</td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="8">
                          {{ 'Purchase_Order_No_Orders_Found' | translateWF: 'No purchase orders found' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <p-paginator
                    [rows]="purchaseOrderPageSize"
                    [totalRecords]="purchaseOrderTotalRecords"
                    [first]="(purchaseOrderCurrentPage - 1) * purchaseOrderPageSize"
                    (onPageChange)="onPurchaseOrderPageChange($event)"
                    [rowsPerPageOptions]="[15, 25, 50, 100]"
                    dropdownAppendTo="body"
                    class="mt-4"
                  ></p-paginator>
                </p-card>
              </p-panel>
            </div>
          }
          @case (2) {
            <div class="cs-page-list-grid">
              <!-- Filters Panel -->
              @if (dispatchRequestFilterConfig() && showFilters()) {
                <csl-dynamic-filters [filterConfig]="dispatchRequestFilterConfig()!" [state]="dispatchRequestFilterState" />
              }

              <!-- Data Table Panel -->
              <p-panel [header]="'Dispatch_Requests' | translateWF: 'Dispatch Requests'">
                <ng-template pTemplate="icons">
                  <p-button
                    [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                    [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                    (click)="showFilters.set(!showFilters())"
                    variant="outlined"
                    size="small"
                  />
                </ng-template>
                <p-card data-variant="compact">
                  <p-table [value]="dispatchRequestList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTableDispatchRequestSort($event)">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
                        <th pSortableColumn="number">
                          {{ 'Dispatch_Request_Number' | translateWF: 'DR Number' }}
                          <p-sortIcon field="number"></p-sortIcon>
                        </th>
                        <th>{{ 'Dispatch_Request_Date_Created' | translateWF: 'Date Created' }}</th>
                        <th>{{ 'Dispatch_Request_Status' | translateWF: 'Status' }}</th>
                        <th>{{ 'Dispatch_Request_Location' | translateWF: 'Location' }}</th>
                        <th>{{ 'Supply_Request_Number' | translateWF: 'Supply Request Number' }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-dispatchRequest>
                      <tr class="cursor-pointer">
                        <td>
                          <p-button
                            icon="pi pi-eye"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            (click)="navigateToDispatchRequest(dispatchRequest.id)"
                            pTooltip="{{ 'Common_View_Details' | translateWF: 'View Details' }}"
                            tooltipPosition="top"
                          />
                        </td>
                        <td>
                          <a>{{ dispatchRequest.number }}</a>
                        </td>
                        <td>{{ dispatchRequest.createdDate | date: 'dd/MM/yyyy' : 'UTC-6' }}</td>
                        <td>{{ getDispatchStatusLabel(dispatchRequest.status) }}</td>
                        <td>{{ localeHelperService.getLocalizedValue(dispatchRequest.locationName) || dispatchRequest.locationCode }}</td>
                        <td>{{ dispatchRequest.supplyRequestNumber || '-' }}</td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="6">
                          {{ 'Dispatch_Request_No_Requests_Found' | translateWF: 'No dispatch requests found' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <p-paginator
                    [rows]="25"
                    [totalRecords]="dispatchRequestList().length"
                    [rowsPerPageOptions]="[15, 25, 50, 100]"
                    dropdownAppendTo="body"
                    class="mt-4"
                  ></p-paginator>
                </p-card>
              </p-panel>
            </div>
          }
          @case (3) {
            <div class="cs-page-list-grid">
              <!-- Filters Panel -->
              @if (externalRequisitionFilterConfig() && showFilters()) {
                <csl-dynamic-filters [filterConfig]="externalRequisitionFilterConfig()!" [state]="externalRequisitionFilterState" />
              }

              <!-- Data Table Panel -->
              <p-panel [header]="'External_Requisitions' | translateWF: 'External Requisitions'">
                <ng-template pTemplate="icons">
                  <p-button
                    [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                    [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                    (click)="showFilters.set(!showFilters())"
                    variant="outlined"
                    size="small"
                  />
                </ng-template>
                <p-card data-variant="compact">
                  <p-table [value]="requisitionList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTableRequisitionSort($event)">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
                        <th pSortableColumn="number">
                          {{ 'Requisition_Number' | translateWF: 'Requisition Number' }}
                          <p-sortIcon field="number"></p-sortIcon>
                        </th>
                        <th>{{ 'Requisition_Date_Created' | translateWF: 'Date Created' }}</th>
                        <th>{{ 'Common_Department' | translateWF: 'Department' }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-req>
                      <tr class="cursor-pointer">
                        <td>
                          <p-button
                            icon="pi pi-eye"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            (click)="navigateToMaterialIssueFromRequisition(req.id)"
                            pTooltip="{{ 'Common_View_Details' | translateWF: 'View Details' }}"
                            tooltipPosition="top"
                          />
                        </td>
                        <td>
                          <a>{{ req.number }}</a>
                        </td>
                        <td>{{ req.createdDate | date: 'dd/MM/yyyy' : 'UTC-6' }}</td>
                        <td>{{ getDepartmentName(req.departmentReference) }}</td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="4">
                          {{ 'Requisition_No_Requisitions_Found' | translateWF: 'No requisitions found' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <p-paginator [rows]="25" [totalRecords]="requisitionList().length" [rowsPerPageOptions]="[15, 25, 50, 100]" dropdownAppendTo="body" class="mt-4"></p-paginator>
                </p-card>
              </p-panel>
            </div>
          }
          @case (4) {
            <app-completed-dispatch-tab />
          }
          @case (5) {
            <div class="cs-page-list-grid">
              <!-- Filters Panel -->
              @if (receivedPurchaseOrderFilterConfig() && showFilters()) {
                <csl-dynamic-filters [filterConfig]="receivedPurchaseOrderFilterConfig()!" [state]="receivedPurchaseOrderFilterState" />
              }

              <!-- Data Table Panel -->
              <p-panel [header]="'Received_Purchase_Orders' | translateWF: 'Received Purchase Orders'">
                <ng-template pTemplate="icons">
                  <p-button
                    [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                    [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                    (click)="showFilters.set(!showFilters())"
                    variant="outlined"
                    size="small"
                  />
                </ng-template>
                <p-card data-variant="compact">
                  <p-table
                    [value]="receivedPurchaseOrderList()"
                    [sortOrder]="1"
                    selectionMode="single"
                    [customSort]="true"
                    (sortFunction)="onTableReceivedPurchaseOrderSort($event)"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
                        <th pSortableColumn="purchaseOrderNumber">
                          {{ 'Purchase_Order_PO_Number' | translateWF: 'PO Number' }}
                          <p-sortIcon field="purchaseOrderNumber"></p-sortIcon>
                        </th>
                        <th>{{ 'Purchase_Order_Date_Created' | translateWF: 'Date Created' }}</th>
                        <th>{{ 'Purchase_Order_Status' | translateWF: 'Status' }}</th>
                        <th>{{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}</th>
                        <th>{{ 'Purchase_Order_ShippingTo' | translateWF: 'Shipping To' }}</th>
                        <th>{{ 'Purchase_Order_Received_Date' | translateWF: 'Received Date' }}</th>
                        <th>{{ 'Purchase_Order_Goods_Receipt_Number' | translateWF: 'Goods Receipt Number' }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-po>
                      <tr class="cursor-pointer">
                        <td>
                          <p-button
                            icon="pi pi-eye"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            (click)="navigateToReceivedPurchaseOrder(po.id)"
                            pTooltip="{{ 'Common_View_Details' | translateWF: 'View Details (Read-Only)' }}"
                            tooltipPosition="top"
                          />
                        </td>
                        <td>
                          <div class="flex items-center gap-2">
                            <a class="whitespace-nowrap">{{ po.purchaseOrderNumber }}</a>
                            @if (isAdministrativePurchaseOrder(po)) {
                              <p-tag severity="warn" [value]="'Purchase_Order_Administrative' | translateWF: 'Administrative'" />
                            }
                          </div>
                        </td>
                        <td>{{ po.createdDate | date: 'dd/MM/yyyy' : 'UTC-6' }}</td>
                        <td>
                          <p-tag [value]="statusesOrder()[po.status]" severity="success" />
                        </td>
                        <td>{{ getSpecificProvider(po.provider) }}</td>
                        <td>{{ getSpecificShippingTo(po.shipTo) }}</td>
                        <td>{{ po.modifiedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-6' }}</td>
                        <td>{{ (po.goodsReceiptNumbers ?? []).join(', ') || '-' }}</td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="8">
                          {{ 'Purchase_Order_No_Received_Found' | translateWF: 'No received purchase orders found' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <p-paginator
                    [rows]="receivedPurchaseOrderPageSize"
                    [totalRecords]="receivedPurchaseOrderTotalRecords"
                    [first]="(receivedPurchaseOrderCurrentPage - 1) * receivedPurchaseOrderPageSize"
                    (onPageChange)="onReceivedPurchaseOrderPageChange($event)"
                    [rowsPerPageOptions]="[15, 25, 50, 100]"
                    dropdownAppendTo="body"
                    class="mt-4"
                  ></p-paginator>
                </p-card>
              </p-panel>
            </div>
          }
          @case (6) {
            <app-internal-return-tab />
          }
          @case (7) {
            <app-provider-return-tab />
          }
        }
      </div>
    </section>
  </div>
</main>
